import { useGql } from '#imports'
import { getSdk as defaultGqlSdk } from '#gql/default'
export const GqlSdks = {
  default: defaultGqlSdk,
}
export const GqClientOps = {"default":["content","navigation","news","newsDetails","organisation"]}
export const GqlContent = (...params) => useGql()('content', ...params)
export const GqlNavigation = (...params) => useGql()('navigation', ...params)
export const GqlNews = (...params) => useGql()('news', ...params)
export const GqlNewsDetails = (...params) => useGql()('newsDetails', ...params)
export const GqlOrganisation = (...params) => useGql()('organisation', ...params)